import detectBrowser from './detectBrowser'

export const currentBrowser = detectBrowser(window.navigator.userAgent)

export default { currentBrowser }
